<template>
  <CustomDialogWrapper dialogHeight="220px" @closeDialog="closeDialog">
    <template #title>
      <p :class="$style.title">请输入新昵称</p>
    </template>
    <template #main-content>
      <van-field
        v-model="userName"
        :class="$style.content"
        placeholder="请输入昵称(最多8个字)"
        maxlength="8"
        clearable
      />
    </template>
    <template #footer>
      <van-button :class="$style.submit" type="info" @click="submit">修改</van-button>
    </template>
  </CustomDialogWrapper>
</template>

<script>
import CustomDialogWrapper from '_c/CustomDialogs/CustomDialogWrapper';
import { Field, Button, Dialog, Toast } from 'vant';
import { setUsername } from '@/api/account';
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
  props: {
    userInfoName: { type: String, default: '' }
  },
  components: {
    CustomDialogWrapper,
    VanField: Field,
    VanButton: Button
  },
  data() {
    return {
      userName: this.userInfoName,
      brushFlag: false
    };
  },
  computed: {
    ...mapState('account', {
      userInfo: state => state.userInfo
    }),
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING'
    }),
    ...mapActions('account', {
      getUserInfo: 'getUserInfo'
    }),
    submit() {
      if (this.userName == this.userInfo.forum_user.forum_name) {
        Toast("新昵称与原昵称相同，不需要修改！");
        return
      }
      if (!this.userName) {
        Toast("昵称不能为空！");
        return
      }
      if (this.brushFlag) return
      this.brushFlag = true
      Dialog.alert({
        title: '修改昵称',
        message: `原昵称“${this.userInfo.forum_user.forum_name}” \n 新昵称“${this.userName}”`,
        showCancelButton: true
      }).then(async () => {
        this.CHANGE_SHOW_LOADING(true)
        const r = await setUsername({
          forum_name: this.userName,
        })
        this.CHANGE_SHOW_LOADING(false)
        Toast.success('修改成功');
        this.getUserInfo();
        this.$emit('closeDialog');
        this.brushFlag = false
      }).catch(error => {
        this.userName = this.userInfo.forum_user.forum_name
        this.CHANGE_SHOW_LOADING(false)
        Toast.fail(error.message);
        this.brushFlag = false
      })
    },
    closeDialog() {
      this.$emit('closeDialog')
    }
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.title {
  margin-bottom: 20px;
  color: #292929;
}
.content {
  @include border-bottom-1px;
}
.submit {
  width: 247px;
  border-radius: 22px;
  background: linear-gradient(-90deg, rgba(36, 180, 254, 1), rgba(82, 208, 255, 1));
  border: none;
}
</style>